import React from 'react';
import { ShieldCheck } from 'lucide-react';

const VesselClassDropdown = ({ value, onChange, error, disabled = false }) => {
  const vesselClassOptions = [
    "American Bureau of Shipping",
    "ASIA Classification Society",
    "Associated Consultants Bureau Ltd",
    "Belize Maritime Bureau Inc",
    "Belize Register Corporation",
    "Black Sea Bureau Of Shipping",
    "Bulgarian Register of Shipping",
    "Bureau Colombo BR",
    "Bureau Veritas",
    "China Classification Society",
    "China Corporation Register of Shipping",
    "Croatian Register of Shipping",
    "Cyprus Bureau of Shipping Det Norske Veritas",
    "Dromon Bureau Of Shipping Germanicher Lloyds",
    "Hellenic Register of Shipping",
    "Icons Marine Services Pte Ltd",
    "Indian Register of Shipping",
    "Inspeccion y Clasificacion Maritima",
    "Instituto Nacional de Los Espacios Acuaticos e Insulares",
    "Intermaritime Certification Services S.A",
    "International Naval Surveys Bureau",
    "International Register of Shipping",
    "International Ship Classification",
    "International Yacht Bureau Inc",
    "Isthmus Bureau of Shipping S.A",
    "Korea Register of Shipping",
    "Lloyd's Register",
    "Macosnar Corporation",
    "Nippon Kaiji Kayokal",
    "P.TBiro Klasifikasi Indonesia",
    "Panama Marine Survey and Certification Services Inc",
    "Panama Maritime Documentation Services",
    "Phoenix register of Shipping S.A",
    "Polish Register of Shipping",
    "Registro Italiano navale",
    "Rinave-Rigistro Internacional Naval S.A"
  ];

  return (
    <div>
      <div className="relative">
        <select
          name="vesselClass"
          value={value}
          onChange={onChange}
          disabled={disabled}
          className={`w-full rounded-lg border px-4 py-2.5 pr-10 appearance-none bg-white focus:outline-none focus:ring-1 ${
            error
              ? "border-red-300 focus:border-red-500 focus:ring-red-100"
              : "border-gray-300 focus:border-[#27ade3] focus:ring-[#cce5f8]"
          } ${disabled ? "opacity-70 cursor-not-allowed" : ""}`}
        >
          <option value="">Select Vessel Class</option>
          {vesselClassOptions.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
        <ShieldCheck className="absolute right-3 top-3 h-4 w-4 text-gray-400 pointer-events-none" />
      </div>
      {error && (
        <p className="text-red-500 text-xs mt-1">{error}</p>
      )}
    </div>
  );
};

export default VesselClassDropdown;